/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

import styled from "styled-components";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetailsDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Apuração resumida");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className="app deatil">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue={selectedValue}
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Apuração resumida"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Apuração resumida"
            />

            <FormControlLabel
              value="Apuração detalhada"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Apuração detalhada"
            />

            <FormControlLabel
              value="Apuração INDEP"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Apuração INDEP"
            />

            <FormControlLabel
              value="Apuração REDE"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Apuração REDE"
            />

            <FormControlLabel
              value="Apuração REDE Consolidado"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Apuração REDE Consolidado"
            />
          </RadioGroup>
        </FormControl>

        {selectedValue === "Apuração resumida" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <Card
                    app={app}
                    exportTable
                    exportTableId="FsRjjcp"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="FsRjjcp"
                      reference={{ id: "FsRjjcp" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}

        {selectedValue === "Apuração detalhada" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <Card
                    app={app}
                    exportTable
                    exportTableId="JLDpeM"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="JLDpeM"
                      reference={{ id: "JLDpeM" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}
        {selectedValue === "Apuração INDEP" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <Card
                    app={app}
                    exportTable
                    exportTableId="aSgnv"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="aSgnv"
                      reference={{ id: "aSgnv" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}
        {selectedValue === "Apuração REDE" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <Card
                    app={app}
                    exportTable
                    exportTableId="NkTNuu"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="NkTNuu"
                      reference={{ id: "NkTNuu" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}
        {selectedValue === "Apuração REDE Consolidado" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "calc(100vh - 150px)",
                  }}
                >
                  <Card
                    app={app}
                    exportTable
                    exportTableId="UdZqJP"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="UdZqJP"
                      reference={{ id: "UdZqJP" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}
      </div>
    </div>
  );
}

DetailsDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsDesktop;
